import Vid from '@tencent/eco-vid';
import TipsModal from 'lib/components/Modal/TipsModal';
import { fetchMSDKDecrypt, fetchWUJISubscribePage } from 'lib/apis';
import { useGlobalStore } from 'lib/store';
import channelService from 'lib/services/channelService';
import mobileStatusService from 'lib/services/mobileOrderPackageService';
import userOrderService from 'lib/services/userOrderService';
import msdkUtil from 'lib/utils/MSDK/index';
import network from 'lib/utils/network';
import session from 'lib/utils/session';
import storage from 'lib/utils/storage';
import { STORAGE } from 'lib/utils/storage/constants';
import { ENV_TYPE } from 'lib/constants/login';
import { ATTA_REPORT_PLATFORM_PC } from 'lib/constants/common';
import { currentUrlParams } from 'lib/utils/url';
import { getHostEnv, getLoginType, getUserType, isiOS } from 'lib/utils/util';
import { isPC } from 'lib/utils/device';
import monitor, { TRACE_ENUM } from 'lib/utils/monitor';
import { addReportPublicParams, initReportUrl, report, setReportPublicParams } from 'lib/utils/dataReport';
import { urlConfig } from 'lib/config';
import cookie from 'lib/utils/cookie';
import { COOKIES_KEY } from 'lib/utils/cookie/constants';
import { validateUrlQueryParams } from 'lib/utils/validation';
import { GAME_NAME_LIST } from './constants';
import 'antd-mobile/es/global';
import './index.scss';

monitor.init();

export default async function init({ data }) {
  userCloseEventListen();
  const {
    gameCode,
    maxMonth,
    subStatTag,
    smsModalTheme,
    pageChannelCode,
    mobileInputModalImg,
    mobileInputModalButtonText,
    landscapeNoticeImg,
    landscapeNoticeText,
    smsModalMobilePromotionImg,
    smsModalDefaultButtonImg,
    freeLotteryModalGiftsImg,
    isShowRetainModal,
  } = data;
  const globalStore = useGlobalStore.getState();
  globalStore.initGlobalData({
    smsModalMobilePromotionImg,
    smsModalDefaultButtonImg,
    smsModalTheme,
    maxMonth: maxMonth || 6,
    mobileInputModalImg,
    mobileInputModalButtonText,
    landscapeNoticeImg,
    landscapeNoticeText,
    freeLotteryModalGiftsImg,
    isShowRetainModal,
  });
  msdkUtil.init();
  const vid = new Vid();
  const gameInfo = GAME_NAME_LIST.find(c => c.value === gameCode);
  channelService.channelName = gameInfo?.label || '';
  channelService.gameCode = gameCode;
  channelService.channelTag = subStatTag;
  const loginType = getLoginType();
  network.setServiceType(channelService.gameCode);
  network.setLoginStatus(loginType);
  initReportUrl(urlConfig.reportUrl);
  cookie.set(COOKIES_KEY.RETURN_URL, window.location.href.replace(/&code=[^&]+/g, ''));
  // 第三方选择登录微信，复制链接时会把填写过的手机号复制到连接上，需要在微信打开时进行回填
  const urlParams = currentUrlParams.getCurrentParams(STORAGE.ORDER_MOBILE);
  if (urlParams) {
    storage.setStorage(STORAGE.ORDER_MOBILE, urlParams);
  }
  // 不依赖loginType 已有默认值
  const channelCode = await initActivityConfig(pageChannelCode);

  if (!channelCode) {
    // 本地开发环境不提示 and 预渲染环境不提示
    if (location.origin.indexOf('localhost') > -1) return;
    TipsModal.show({
      content: '系统繁忙，请重新加载页面',
      confirmText: '重试',
      confirmCallback: () => {
        window.location.reload();
      },
    });
    return;
  }

  channelService.channelCode = channelCode;
  // 设置上报公参
  setReportPublicParams({
    vid: vid.getId(),
    gameCode: channelService.gameCode,
    channelCode: channelService.channelCode,
    pageRefer: 1,
    statTag: currentUrlParams.getCurrentParams('SubStatTag') || subStatTag,
    platform: isPC() ? ATTA_REPORT_PLATFORM_PC : (isiOS() ? 1 : 2),
    environment: getHostEnv(),
    userType: Number(getUserType()),
    loginType: +loginType,
    expKey: cookie.get('page_hash') || '',
  });
  if (loginType === ENV_TYPE.GUEST) {
    const mobile = storage.getStorage(STORAGE.ORDER_MOBILE);
    // 设置唯一设备ID
    monitor.setMonitorConfig(vid.getId());
    monitor.reportLog({
      actionName: TRACE_ENUM.VIEW,
    });
    // 上报自定义事件用于告警
    monitor.reportEvent(TRACE_ENUM.VIEW);
    report('act_view_view');
    mobile && (await mobileStatusService.queryMobileOrderStatus(mobile));
    globalStore.completeInit();
    return;
  }
  let uin = currentUrlParams.getCurrentParams('openid') || session.getSessionData().token;
  if (!uin && msdkUtil.isMSDK) {
    const res = await fetchMSDKDecrypt();
    if (res?.code === 0) {
      uin = res.data.openID;
    }
  }
  monitor.setMonitorConfig(uin);
  monitor.reportLog({
    actionName: TRACE_ENUM.VIEW,
  });
  monitor.reportEvent(TRACE_ENUM.VIEW);
  addReportPublicParams({
    openid: uin,
  });
  // 查询用户订单状态
  await userOrderService.handleUserOrderInfo(channelCode);
  globalStore.completeInit();
  report('act_view_view');
  validateUrlQueryParams();
}

async function initActivityConfig(pageChannelCode) {
  const res = await fetchWUJISubscribePage();
  if (res?.code !== 0) return;
  const { data } = res;
  const { channel_code: channelCode } = data?.[0];
  // 如果页面没有传渠道编码，直接返回接口返回的渠道编码
  if (!pageChannelCode) return channelCode;

  // 判断当前渠道是否合法
  const isChannelCodeLegal = data.some(item => item.channel_code === pageChannelCode);
  // 如果页面传的渠道编码不合法，直接返回接口返回的渠道编码
  if (!isChannelCodeLegal) {
    monitor.reportLog({
      actionName: 'illegal channelCode',
    });
    return channelCode;
  }
  return pageChannelCode;
}

// 用户离开上报
function userCloseEventListen() {
  window.addEventListener('beforeunload', () => {
    monitor.reportLog({
      actionName: TRACE_ENUM.CLOSE,
    });
    return false;
  });
}
